export const createCollectionLink = (siteId: string, collectionId: string): string =>
  `/sites/${siteId}/highlights/${collectionId}`;
